import DirectionsBoatRoundedIcon from "@mui/icons-material/DirectionsBoatRounded";
import { IconProps } from "./types";

export function BoatIcon({ size, ...props }: IconProps) {
    return <DirectionsBoatRoundedIcon fontSize={size} {...props} />;
}
